import LanguageData from './language-data.json';
export default LanguageData;